export default __webpack_public_path__ + "static/media/shuffle.88b91146.svg";